import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomepageNewsComponent } from './homepage-news/homepage-news.component';
import {WidgetsModule} from '../../widgets/widgets.module';
import {TranslateModule} from '@ngx-translate/core';
import {SwiperModule} from 'ngx-swiper-wrapper';
import {BoxesModule} from '../../boxes/boxes.module';
import { HomepageProductInEvidenceComponent } from './homepage-product-in-evidence/homepage-product-in-evidence.component';
import {DirectivesModule} from '../../providers/directives/directives.module';
import { HomepageCatalogComponent } from './homepage-catalog/homepage-catalog.component';
import { HomepageSectorsComponent } from './homepage-sectors/homepage-sectors.component';
import { HomepageStatisticsComponent } from './homepage-statistics/homepage-statistics.component';
import { HomepageElsaComponent } from './homepage-elsa/homepage-elsa.component';
import {RouterModule} from '@angular/router';
import {PipesModule} from '../../providers/pipes/pipes.module';
import {LocalizeRouterModule} from '@gilsdav/ngx-translate-router';



@NgModule({
  declarations: [HomepageNewsComponent, HomepageProductInEvidenceComponent, HomepageCatalogComponent, HomepageSectorsComponent, HomepageStatisticsComponent, HomepageElsaComponent],
  imports: [
    CommonModule,
    WidgetsModule,
    TranslateModule,
    SwiperModule,
    BoxesModule,
    DirectivesModule,
    RouterModule,
    PipesModule,
    LocalizeRouterModule
  ],
  exports: [HomepageNewsComponent, HomepageProductInEvidenceComponent, HomepageCatalogComponent, HomepageSectorsComponent, HomepageStatisticsComponent, HomepageElsaComponent]
})
export class HomepageModule { }
